import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { 
  chartColorCodeForFeedModalPieChart
} from './colorCodes';
import {
  CHART_BACKGROUND_COLOUR,
  DEFAULT_NO_DATA_OPTIONS,
  SERIES_KEY,
} from './constants/HighchartsConstants'
import {
  POSITIVE,
  NEGATIVE,
  NEUTRAL,
  JOY,
  NO_SPECIFIC_EMOTION,
  SENTIMENT,
  EMOTION
} from '../../home/redux/constants';

class PieChartForFeedModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      feed: {
        emotionCounts: {},
        sentiment: {},
        relevantCommentCount: 0
      },
      chartData: [],
      mapDataFromProps: [],
      mapOptions: {
        chart: {
          type: 'pie',
          backgroundColor: CHART_BACKGROUND_COLOUR,
          marginBottom: 0,
          marginTop: 25
        },

        plotOptions: {
          pie: {
            center: ['50%', '50%'],
            dataLabels: {
              enabled: true,
              distance: -21,
              style: {
                textOutline: false,
                fontSize: '1em',
                fontWeight: 'normal',
                color: chartColorCodeForFeedModalPieChart.label,
              },
              filter: {
                property: 'y',
                operator: '>',
                value: 0
              }
            },
          },
        },
        noData: {...DEFAULT_NO_DATA_OPTIONS},
        title: '',
        tooltip: { enabled: false },
        credits: { enabled: false },
        yAxis: { title: '' },
      },
    };
  }

  _reRenderChartOnChange = props => {
    if (props.feed.relevantCommentCount === 0) {
      return
    }
    this.setState(
      {
        feed: props.feed,
        chartData: []
      }
    );

    const chartData = [];
    let emotionCountsChartData = this._parseFeedDataToEmotionChartData(props.feed);
    let sentimentCountsChartData = this._parseFeedDataToSentimentChartData(props.feed);
    let { mapOptions } = this.state;
    mapOptions[SERIES_KEY] = [{
      name: SENTIMENT,
      data: sentimentCountsChartData,
      size: '45%',
      dataLabels: {
          format: '<b>{point.name}: {y}</b>',
          distance: '-50%'
      }
  }, {
      name: EMOTION,
      data: emotionCountsChartData,
      size: '80%',
      innerSize: '60%',
      dataLabels: {
          format: '<b>{point.name}: {y}</b>',
      }
  }];
    this.setState({
    chartData,
    mapOptions,
    });
  };

  _parseFeedDataToSentimentChartData(feed) {

    let sentimentCountsDict = Object.assign({}, ...feed.sentiment.map((x) => ({[x.category]: x.total})));
    let sentimentCountsChartData = [
      {
        name: this._capitaliseFirstLetterOfPieChartCategoryLabel(POSITIVE),
        color: chartColorCodeForFeedModalPieChart[POSITIVE],
        y: sentimentCountsDict[POSITIVE]
      },
      {
        name: this._capitaliseFirstLetterOfPieChartCategoryLabel(NEUTRAL),
        color: chartColorCodeForFeedModalPieChart[NEUTRAL],
        y: sentimentCountsDict[NEUTRAL]
      },
      {
        name: this._capitaliseFirstLetterOfPieChartCategoryLabel(NEGATIVE),
        color: chartColorCodeForFeedModalPieChart[NEGATIVE],
        y: sentimentCountsDict[NEGATIVE]
      },
    ];
    return sentimentCountsChartData;
  };

  _parseFeedDataToEmotionChartData(feed) {

    let neutralCount = 0;
    for (let sentiment of feed.sentiment) {
      if (sentiment.category === NEUTRAL) {
        neutralCount = sentiment.total;
        break;
      }
    }
    let emotionCountsChartData = [
      {
        name: this._capitaliseFirstLetterOfPieChartCategoryLabel(JOY),
        color: chartColorCodeForFeedModalPieChart[JOY],
        y: feed.emotionCounts[JOY]
      },
      {
        name: this._capitaliseFirstLetterOfPieChartCategoryLabel(NO_SPECIFIC_EMOTION),
        color: chartColorCodeForFeedModalPieChart[NO_SPECIFIC_EMOTION],
        y: neutralCount
      }
    ];
    for (const [key, value] of Object.entries(feed.emotionCounts)) {
      if (key !== JOY && key !== NO_SPECIFIC_EMOTION) {
        emotionCountsChartData.push({
          name: this._capitaliseFirstLetterOfPieChartCategoryLabel(key),
          color: chartColorCodeForFeedModalPieChart[key],
          y: value
        });
      }
    }
    
    return emotionCountsChartData;
  };

  _capitaliseFirstLetterOfPieChartCategoryLabel(category) {
    return category.charAt(0).toUpperCase() + category.slice(1);
  }

  componentDidMount() { 
    this._reRenderChartOnChange(this.props); 
  }

  componentDidUpdate(_, nextProps) {
    if (this._shouldReRenderChartBasedOnNewProps(nextProps)) {
      this._reRenderChartOnChange(nextProps);
    }
  }

  _shouldReRenderChartBasedOnNewProps(nextProps) {
    return (
      this._doesNewPropsFeedEmotionCountsDifferFromCurrentStateAndProps(nextProps) ||
      this._doesNewPropsFeedSentimentCountsDifferFromCurrentStateAndProps(nextProps)
    );
  }

  _doesNewPropsFeedEmotionCountsDifferFromCurrentStateAndProps(nextProps) {
    return (JSON.stringify(this.state.feed.emotionCounts) !== JSON.stringify(nextProps.feed.emotionCounts));
  }

  _doesNewPropsFeedSentimentCountsDifferFromCurrentStateAndProps(nextProps) {
    return (JSON.stringify(this.state.feed.sentiment) !== JSON.stringify(nextProps.feed.sentiment));
  }

  render() {
    const { feed, mapOptions } = this.state;
    return (
      <div className='controversy-indices-card'>
        <span className="controversy-index-title">
            Comments Breakdown
        </span>
        {feed && feed.relevantCommentCount > 0 ? (
            <HighchartsReact
            highcharts={Highcharts}
            options={mapOptions}
            allowChartUpdate={true}
            immutable={false}
            updateArgs={[true, true, true]}
            />
        ) : (
            <HighchartsReact highcharts={Highcharts} options={mapOptions} />
        )}
      </div>
    );
  }
}

export default PieChartForFeedModal;


// WEBPACK FOOTER //
// ./src/features/shared-components/chart/PieChartForFeedModal.js